import { render } from "./pc_destination_list.vue?vue&type=template&id=40009abc&scoped=true"
import script from "./pc_destination_list.vue?vue&type=script&scoped=true&lang=js"
export * from "./pc_destination_list.vue?vue&type=script&scoped=true&lang=js"

import "./pc_destination_list.vue?vue&type=style&index=0&id=40009abc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40009abc"]])

export default __exports__